import React, { useMemo } from "react";
import {
	DebitListForACH,
	DebitListForCash,
	DebitListForCreditCard,
	DebitListSwitcher
} from "@icoach/batchPayment/component";
import {
	SUB_TAB,
	PAYMENT_METHODS, preserveSearchParams, MAIN_TAB, ORDER_TYPES
} from "@icoach/batchPayment/staticData";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";
import {Link} from 'react-router-dom';
import {mergeQueryToUrl} from '@util/utils';
import {ACCOUNT_BOOK_BULK_DEBIT_URL} from '@icoach/router/routerPath';


/** ================================
 * 📌 會籍月費當期扣款名單
 *  ================================
 */
const MembershipBatchPaymentCurrentDebitList = () => {
	const { searchParams, batchPaymentLists, dialogRef, getBatchPayments } = useBatchPaymentContext();

	const paymentMethodActions = useMemo(() => {
			const { creditItems, achItems, cashItems} = batchPaymentLists || {};
			return {
				[PAYMENT_METHODS.CREDIT]: {
					label: "信用卡",
					value: PAYMENT_METHODS.CREDIT,
					buttonComponent: Link,
					to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.CURRENT,
						[SUB_TAB]: PAYMENT_METHODS.CREDIT
					})),
					debitListComponent: <DebitListForCreditCard sourceData={batchPaymentLists}
																searchParams={searchParams} dialogRef={dialogRef}
																refresh={getBatchPayments}/>,
					listData: creditItems || []
				},
				[PAYMENT_METHODS.ACH]: {
					label: "ACH",
					value: PAYMENT_METHODS.ACH,
					to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.CURRENT,
						[SUB_TAB]: PAYMENT_METHODS.ACH
					})),
					buttonComponent: Link,
					debitListComponent: <DebitListForACH sourceData={batchPaymentLists} searchParams={searchParams}
														 dialogRef={dialogRef} refresh={getBatchPayments}/>,
					listData: achItems || []
				},
				[PAYMENT_METHODS.CASH]: {
					label: "現金",
					value: PAYMENT_METHODS.CASH,
					to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
						[MAIN_TAB]: ORDER_TYPES.CURRENT,
						[SUB_TAB]: PAYMENT_METHODS.CASH
					})),
					buttonComponent: Link,
					debitListComponent: <DebitListForCash sourceData={batchPaymentLists} searchParams={searchParams}
														  dialogRef={dialogRef} refresh={getBatchPayments}/>,
					listData: cashItems || []
				}
			};
		},
		// eslint-disable-next-line
		[searchParams, batchPaymentLists, getBatchPayments]);

	return <DebitListSwitcher sourceData={paymentMethodActions}
							  currentPaymentMethod={searchParams[SUB_TAB]} />;
};

export default MembershipBatchPaymentCurrentDebitList;